import { useContext, useEffect, useState } from "react";
import { Context_UI } from "../../Contexts/Context_UI";
import Icon_Down from '../../Assets/Icons/Icon_Arrow_Down.png'
import UI_Icon from "./UI_Icons";
export default function UI_Dropdown({
    id,
    InitialTitle,
    Items,
    Selected,
    Fill,
    Label_Text,
    Item_Key,
    Required,
    onChange
}) {
    const UI = useContext(Context_UI);
    const [State, State_Set] = useState("Inactive");

    const Toggle = () => {
        if (State == "Active") {
            State_Set("Animating");
            UI.Dropdown_ToggleList(id);
            setTimeout(function () {
                State_Set("Inactive");
            }, 500);
        } else if (State == "Inactive") {
            State_Set("Active");
            UI.Dropdown_ToggleList(id);
        }
    }

    const Handle_Submit = (ID, Value, Index) => {
        UI.Dropdown_SubmitValue(ID, Value, Index);
        if (onChange) {
            onChange({ ID, Value, Index });
        }
    }

    return (
        <>
            {Label_Text ? (
                <label className="Input_Label" htmlFor={id}>
                    {Label_Text}
                    {Required ? <p className="Input_Label_Required">*</p> : ""}
                </label>
            ) : null}

            <div className="Dropdown" id={id} State={State == "Active" || State == "Animating" ? "Active" : "Inactive"} Fill_Horizontal={Fill ? "true" : null}>
                <button type="button" className="Dropdown_Button" onClick={Toggle} Fill_Horizontal>
                    <span className="Dropdown_Button_Text"> {Selected != null ? Selected : InitialTitle} </span>
                    {/* <div className="Dropdown_Button_Arrow">
                        <UI_Icon Name="Arrow_Down"/>
                    </div> */}
                    <img className='Dropdown_Button_Arrow' src={Icon_Down} draggable='false' loading='lazy' />
                </button>
                {State == "Active" || State == "Animating" ?
                    <div type="button" className="Dropdown_List">
                        {Items.map((Item, index) => (
                            <>
                                {/* {Item_Key ?
                                    <button className="Dropdown_List_Item" onClick={() => UI.Dropdown_SubmitValue(id, Item[Item_Key], index)}>
                                        {Item[Item_Key]}
                                    </button>
                                    :
                                    <button className="Dropdown_List_Item" onClick={() => UI.Dropdown_SubmitValue(id, Item, index)}>
                                        {Item}
                                    </button>
                                } */}
                                {Item_Key ?
                                    <button className="Dropdown_List_Item" onClick={() => Handle_Submit(id, Item[Item_Key], index)}>
                                        {Item[Item_Key]}
                                    </button>
                                    :
                                    <button className="Dropdown_List_Item" onClick={() => Handle_Submit(id, Item, index)}>
                                        {Item}
                                    </button>
                                }
                            </>

                        ))}
                    </div>
                    :
                    ""
                }
                <p className="Dropdown_Prompt" id={`${id}_Prompt`}>

                </p>
            </div>


        </>
    )
}

